import RootState from '@/store/root_state';
import { GetterTree } from 'vuex';
import dayjs from 'dayjs';

const getters: GetterTree<{}, RootState> = {
  isOnboardingExperienceActive: (_state, _getters, _rootState, rootGetters): boolean => {
    try {
      const {
        shouldShowClassroomsUgOnboarding,
        onboardingDiscipline,
        regularDisciplines,
        getActiveStudyWindow,
      } = rootGetters;

      const hasNoRegularDisciplines = regularDisciplines.length === 0;

      const firstComplementaryStudyWindow = getActiveStudyWindow(
        onboardingDiscipline?.studyWindowId,
      );
      const isFirstComplementaryStudyWindowStartDateValid =
        firstComplementaryStudyWindow && dayjs().isBefore(firstComplementaryStudyWindow.startDate);

      return (
        shouldShowClassroomsUgOnboarding &&
        !!onboardingDiscipline &&
        (hasNoRegularDisciplines || isFirstComplementaryStudyWindowStartDateValid)
      );
    } catch (error) {
      return false;
    }
  },
};

export default getters;
